<div class="opm-grid">

  @if (!isAudit && gridresult==gridResultEnum.Search) {
    <div class="grid-caption">
      Search Results
      <span class="grid-hint modified">Modified Record</span>
      <span class="grid-hint edited">Edited in the Past</span>
    </div>
  }
  @if (!isAudit && (gridresult==gridResultEnum.Basemapping) ) {
    <div class="grid-caption">
      Base Mappings
      @if (isEnabledFilter) {
        <button class="value" (click)="downloadExcel(excelEnum.ExportBaseMappingEnabled)">Export Current List</button>
      }
    </div>
  }
  @if (!isAudit && (gridresult==gridResultEnum.OnboardedApp) ) {
    <div class="grid-caption">
      OnBoarded Applications &nbsp;&nbsp;&nbsp;<span class="grid-caption-count"> Total Count : #{{totalRecords}}</span>
      <button class="value" (click)="downloadExcel(excelEnum.OnBoardedAppsEnabled)">
        Export Current List
      </button>
    </div>
  }
  @if (!isAudit && (gridresult==gridResultEnum.Containermapping) ) {
    <div class="grid-caption">
      Application Container Mappings
      <button class="value" (click)="downloadExcel(excelEnum.ExportFilterMappingsEnabled)">Export Current List</button>
    </div>
  }
  @if (!isAudit && gridresult==gridResultEnum.Modified) {
    <div class="grid-caption">
      Modified Results
      <span class="grid-hint modified">Modified Record</span>
      <span class="grid-hint edited">Edited in the Past</span>
    </div>
  }
  @if (!isAudit && gridresult==gridResultEnum.Sync) {
    <div class="grid-caption">
      Duplicate records
    </div>
  }
  @if (isAudit) {
    <div class="grid-caption">
      Audit Logs for Profile: {{users[0].PreferredFullName}}
      <div class="caption-item">Global Person Id (EMPGUID): <span class="value">{{users[0].GlobalPersonId}}</span></div>
      <div class="caption-item">Person Id (EmpCode): <span class="value">{{users[0].PersonId}}</span></div>
      <div class="caption-item">Previous Person Id: <span class="value">{{users[0].PreviousEmployeeCode}}</span></div>
    </div>
  }
  <div class="grid-header">
    @for (header of metadata; track header) {
      <span class="header-item" [ngClass]="{'email-cell': header.columnName == 'email'}"
      [ngStyle]="{'width': header.width}"> {{header.title}}</span>
    }
  </div>
  @for (user of users; track user; let isEven = $even) {
    <div class="grid-item"
      [ngClass]="{odd: isEven, edited: user.OverrideStatus == overrideStatusEnum.Edited, modified: user.OverrideStatus == overrideStatusEnum.Modified}">
      @if ((gridresult==gridResultEnum.Containermapping || gridresult==gridResultEnum.Basemapping || gridresult==gridResultEnum.OnboardedApp)) {
        <span [ngStyle]="{'width': '100px'}">{{user.Id}}</span>
      }
      @if (!isAudit && (gridresult==gridResultEnum.Containermapping || gridresult==gridResultEnum.Basemapping)) {
        <span [ngStyle]="{'width': '150px'}">{{user.Name}}</span>
      }
      @if (!isAudit && (gridresult==gridResultEnum.Containermapping)) {
        <span [ngStyle]="{'width': '150px'}">{{user.ContainerCode}}</span>
      }
      @if (!isAudit && (gridresult==gridResultEnum.Containermapping || gridresult==gridResultEnum.Basemapping || gridresult==gridResultEnum.OnboardedApp)) {
        <span [ngStyle]="{'width': '150px'}">{{user.Code}}</span>
      }
      @if ((gridresult==gridResultEnum.OnboardedApp)) {
        <span [ngStyle]="{'width': '150px'}">{{user.Description}}</span>
      }
      @if ((gridresult==gridResultEnum.Containermapping || gridresult==gridResultEnum.Basemapping)) {
        <span [ngStyle]="{'width': '150px'}">{{user.Memberfirmcode}}</span>
      }
      @if ((gridresult==gridResultEnum.Containermapping || gridresult==gridResultEnum.Basemapping)) {
        <span [ngStyle]="{'width': '150px'}">{{user.Countrycode}}</span>
      }
      @if ((gridresult==gridResultEnum.Containermapping)) {
        <span [ngStyle]="{'width': '150px'}">{{user.Countryname}}</span>
      }
      @if ((gridresult==gridResultEnum.Basemapping)) {
        <span [ngStyle]="{'width': '150px'}">{{user.CountryName}}</span>
      }
      @if ((gridresult==gridResultEnum.Containermapping || gridresult==gridResultEnum.Basemapping)) {
        <span [ngStyle]="{'width': '150px'}">{{user.Officecode}}</span>
      }
      @if ((gridresult==gridResultEnum.Containermapping || gridresult==gridResultEnum.Basemapping)) {
        <span [ngStyle]="{'width': '150px'}">{{user.Geocode}}</span>
      }
      @if (!isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '65px'}">{{user.GuidFromPdi}}</span>
      }
      @if (!isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '65px'}">{{user.GlobalPersonId}}</span>
      }
      @if (!isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '65px'}">{{user.PersonId}}</span>
      }
      @if (!isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '65px'}">{{user.PreviousEmployeeCode}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '60px'}">{{user.MemberFirmCode}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '100px'}">{{user.CountryCode}} - {{user.CountryDesc}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '70px'}">{{user.FirstName}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '70px'}">{{user.LastName}}</span>
      }
      @if (isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '90px'}">{{user.OutlookDisplayName}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '100px'}">{{user.EmployeeAlias}}</span>
      }
      <span [ngStyle]="{'width': '100px'}" class="email-cell">@if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <a href="mailto:{{user.Email}}">{{user.Email}}</a>
      }</span>
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '100px'}">{{user.OfficeCode}} - {{user.OfficeDesc}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '100px'}">{{user.JobTitle}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '70px'}">{{user.EmployeeType}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '90px'}">{{user.EmployeeStatusCode}} - {{user.EmployeeStatusDesc}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '100px'}">
          Mob:{{user.MobilePhone}} <br />
          Work:{{user.WorkPhone}}
        </span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '100px'}">{{user.OrganizationCode}} - {{user.OrganizationDesc}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '50px'}">{{user.PPMD | booleanFormatterPipe}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '80px'}">{{user.Region}}</span>
      }
      @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '100px'}">{{user.PersonnelAreaCode}} - {{user.PersonnelAreaDesc}}</span>
      }
      @if (isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '70px'}">
          {{user.CreatedByName}} {{
          user.CreatedDate |
          date:'short'
          }}
        </span>
      }
      @if (isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '70px'}">
          {{user.InactiveByName}} {{
          user.InactiveDate |
          date:'short'
          }}
        </span>
      }
      @if (isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '55px'}">{{user.Comment}}</span>
      }
      @if (isAudit && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '55px'}">{{user.TicketNumber}}</span>
      }
      @if (metaName == gridTypeEnum.Main && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '20px'}">
          @if (gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
            <span class="icon edit" [routerLink]="['/editProfile', user.GlobalPersonUid]" [skipLocationChange]="true"></span>
          }
          @if (readWriteAccessData && user.OverrideStatus == overrideStatusEnum.Modified && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
            <span class="icon revert" (click)="selectedUser = user; visiblMessagePopup = true"
              >
            </span>
          }
          @if ((user.OverrideStatus == overrideStatusEnum.Edited ||
            user.OverrideStatus == overrideStatusEnum.Modified) && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
            <span class="icon view" [routerLink]="['/auditLog', user.GlobalPersonUid]" [skipLocationChange]="true">
            </span>
          }
        </span>
      }
      @if (readWriteAccessData && metaName == gridTypeEnum.Sync && gridresult!=gridResultEnum.Containermapping && gridresult!=gridResultEnum.Basemapping && gridresult!=gridResultEnum.OnboardedApp) {
        <span [ngStyle]="{'width': '25px'}">
          <button class="btn btn-primary sync-btn" (click)="syncUser(user)">Sync</button>
        </span>
      }
    </div>
  }
  @if (visiblMessagePopup) {
    <opm-modal-popup
      [header]="selectedUser.HasErrors ? 'Revert failed' : 'Revert record modification'"
                   [message]="selectedUser.HasErrors ?
                     'Unable to revert data. Data from the latest OPM feed for profile is not valid.' :
                     'By Reverting this record all values will be updated to the latest OPM feed. Are you sure you want to Revert?'" (onOk)="revert(selectedUser)"
      [okButtonName]="selectedUser.HasErrors ? 'Ok' : 'Revert'" (onCancel)="visiblMessagePopup = false"
      [cancelVisibility]="!selectedUser.HasErrors">
    </opm-modal-popup>
  }
  @if (visiblErrorPopup) {
    <opm-modal-popup header="Error" [cancelVisibility]="false" [message]="errorMessage"
      okButtonName="Ok" (onOk)="visiblErrorPopup = false">
    </opm-modal-popup>
  }
</div>
